module.exports = __webpack_public_path__ + "media/images/shared/logotypes/logo_hallsberg-448bcde8a17905d0a770d4dbf2f6b5b4.png";